export default __webpack_public_path__ + "static/Aeonik-BoldItalic-9cbd941260407361e4d9101fee020d9e.otf";